/**
 *
 * @param locale
 * @returns {string}
 */
const getLanguageSwitcherDefaultUrlByLocale = locale => {
  if (locale === "fr") {
    return "/"
  }

  return "/" + locale
}

/**
 *
 * @param locale
 * @param translatedUrls
 * @returns {string|*}
 */
const getLanguageSwitcherUrlByLocale = (locale, translatedUrls, isWP) => {
  let url = "/" // Home path by default

  if (!translatedUrls) {
    return url
  }

  try {
    const translatedUrlsArray = JSON.parse(translatedUrls)

    if (!translatedUrlsArray) {
      throw ""
    }

    // Remove locale part from path. It will be added by gatsby-plugin-react-intl
    return !isWP
      ? translatedUrlsArray[locale].replace(`/${locale}`, "")
      : translatedUrlsArray[locale]
  } catch (e) {
    return url
  }
}

/**
 *
 * @param locale
 * @param alias
 * @returns {string|*}
 */
const generateUrlByLocale = (locale, alias) => {
  if (locale === "fr") {
    return alias
  }

  return "/" + locale + alias
}

/**
 *
 * @param locale
 * @param alias
 * @returns {string|*}
 */
const generateUrlForStaticPages = (locale, alias) => {
  let url

  switch (alias) {
    case "#request-quote":
      url = locale === "en" ? "/en/mauritius-hotels/ask-quote" : "/demandez-un-devis"
      break
    case "#flight":
      url =
        locale === "en"
          ? "/en/online-booking-flight-request"
          : "/demande-de-devis-hotel-vol"
      break
    case "#listing-offers":
      url = locale === "en" ? "/en/hotels-mauritius/special-offers-deals" : "/hotels-ile-maurice/offres-speciales"
      break
    case "#contact-us":
      url = locale === "en" ? "/en/contact-en" : "/contact"
      break
    case "#blog":
      url = locale === "en" ? "/blog" : "/blog/fr/"
      break
    case "#sitemap":
      url = locale === "en" ? "/en/sitemap-en" : "/sitemap-fr"
      break
    default:
      url = alias
      break
  }

  return url
}

export {
  getLanguageSwitcherDefaultUrlByLocale,
  getLanguageSwitcherUrlByLocale,
  generateUrlByLocale,
  generateUrlForStaticPages,
}
